export enum CalendarProviderType {
    Unknown = 'Unknown',
    TeamSnap = 'TeamSnap',
}

export const allSupportedCalendarProviderTypes = Object.freeze<CalendarProviderType>([
    CalendarProviderType.TeamSnap,
]);
